<script setup>
import {ref, watch} from 'vue'
import {useRouter} from 'vue-router'
import moment from 'moment'

// Component Imports
import DisplayTitle from '@/common/DisplayTitle'
import api from '@/services/api'

const props = defineProps({
    options: Object,
})

const emit = defineEmits(['hide-modal'])

const router = useRouter()

// Async state replacement using pure Vue 2.7 core
const items = ref(null)

watch(
    () => props.options?.customerId,
    async (customerId) => {
        if (!customerId) {
            items.value = null
            return
        }
        try {
            const response = await api.get('api/component/odp_credit_log', {
                params: {
                    customerId: customerId,
                    sort: '-createdDate',
                }
            })
            items.value = response?.data?.items || []
        } catch (error) {
            console.error('Failed to fetch credit log items:', error)
            items.value = []
        }
    },
    {immediate: true}
)

const getDate = (timestamp) => {
    if (!timestamp) return ''
    const dateValue = timestamp * 1000
    return moment(dateValue).format("DD MMM 'YY @ HH:mm")
}

const openBooking = (bookingId) => {
    router.push({
        name: 'form',
        params: {
            component: 'odp_course_bookings',
            id: bookingId
        }
    })

    emit('hide-modal')
}
</script>

<template>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Credit history</h4>
                <button
                    type="button"
                    class="btn-close"
                    @click="emit('hide-modal')"
                    aria-label="Close"
                ></button>
            </div>

            <div class="modal-body">
                <table v-if="items" class="table table-condensed">
                    <thead>
                    <tr>
                        <td>Amount</td>
                        <td>Franchise</td>
                        <td>Booking</td>
                        <td>User</td>
                        <td>Note</td>
                        <td class="text-end">Date</td>
                    </tr>
                    </thead>

                    <tbody>
                    <tr v-for="item in items" :key="item.id"
                        :class="{'table-warning': item.note?.startsWith('Expired')}">
                        <td>
                            <template v-if="item.debited">(£{{ item.amount }})</template>
                            <template v-else>£{{ item.amount }}</template>
                        </td>

                        <td>
                            <DisplayTitle :table-name="'odp_franchises'" :id="item.franchiseId"/>
                        </td>

                        <td>
                            <a v-if="item.bookingId" href @click.prevent="openBooking(item.bookingId)">
                                {{ item.bookingId }}
                            </a>
                        </td>

                        <td>
                            <DisplayTitle v-if="item.createdBy" :table-name="'users'" :id="item.createdBy"/>
                        </td>

                        <td>{{ item.note }}</td>

                        <td class="text-end">{{ getDate(item.createdDate) }}</td>
                    </tr>
                    </tbody>
                </table>
                <div v-else class="text-center p-3">Loading history...</div>
            </div>
        </div>
    </div>
</template>